"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    height: "24",
    viewBox: "0 0 68.91 24",
    width: "68.91",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "#93c01f"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "m68.13 0h-67.35a.77.77 0 0 0 -.78.78v15.66a.79.79 0 0 0 .56.75l3.41 1v5a.78.78 0 0 0 1.56 0v-4.56l3.59 1a.78.78 0 0 0 .22 0h25.12a.78.78 0 0 0 0-1.56h-4.32v-16.51h32.45v16.58h-.53a.78.78 0 0 0 0 1.56h6.07a.78.78 0 0 0 .78-.78v-18.14a.78.78 0 0 0 -.78-.78zm-55.49 1.56h6.62v16.58h-6.62zm8.18 0h7.76v16.58h-7.76zm-19.26 14.29v-14.29h9.52v16.58h-1.62zm65.79 2.29h-3.2v-16.58h3.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m48.2 16.17a3.92 3.92 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm0 6.27a2.36 2.36 0 1 1 2.35-2.36 2.36 2.36 0 0 1 -2.35 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m57 16.17a3.92 3.92 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm0 6.27a2.36 2.36 0 1 1 2.35-2.36 2.36 2.36 0 0 1 -2.35 2.36z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m39.42 16.17a3.92 3.92 0 1 0 3.91 3.91 3.92 3.92 0 0 0 -3.91-3.91zm0 6.27a2.36 2.36 0 1 1 2.35-2.36 2.36 2.36 0 0 1 -2.35 2.36z"
  })), /*#__PURE__*/_react["default"].createElement("path", {
    d: "m43.63 14.29v-10.95l9.13 5.47z",
    fill: "#9ece06"
  }));
};

exports["default"] = _default;